import { ReportChartGroupItemMeasure } from '@vision/ui/interfaces';

export const ExTrendChart1Measures: ReportChartGroupItemMeasure[] = [
  {
    type: 'feedback',
    items: [
      'feedback-count',
      'feedback-elc-score',
      'feedback-candidate-score',
      'feedback-nps',
      'feedback-csat',
      'feedback-ces',
      'feedback-sentiment-score',
      'feedback-weighted-score',
    ],
  },
];
